import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';
import { FormManagerPageReducerHelper } from '../form-manager-page.reducer-helper';

export const groupUpdateReducer = (
    state = initialState,
    action: actions.GroupUpdate
): State => {
    if (
        !state.group.ids.find(id => id === action.payload.group.id)
    ) {
        return state;
    }

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            groups: arrayPushUnique(state.dirtyIds.groups, action.payload.group.id)
        },
        group: {
            ...state.group,
            entities: {
                ...state.group.entities,
                [action.payload.group.id]: action.payload.group
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/group-update.reducer.ts